exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".usertype {\r\n    margin-right: 15px;\r\n    vertical-align: top;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/feedback/feedback.component.css
// module id = ../../../../../src/app/components/feedback/feedback.component.css
// module chunks = 0